const buttonStates = {
  default: window?.mealPlan?.mealPlan?.add_more_label,
  updating: "Updating...",
  updated: window?.mealPlan?.mealPlan?.proceed_to_addons,
};


function addEventListeners() {
  const checkoutButton = document.querySelector("#meal-plan-cart-cta");
  const mobileCheckoutButton = document.querySelector("#mob-next-step");

  if (!checkoutButton) return;
  if (!mobileCheckoutButton) return;

  const checkoutButtonCounter = checkoutButton.querySelector(".meal-plan-cart-cta__counter");
  const mobileCheckoutButtonCounter = mobileCheckoutButton.querySelector(".meal-plan-cart-cta__counter");


  document.addEventListener("cart-update", (data) => {
    handleButtonUpdate(checkoutButton, checkoutButtonCounter, data.detail);
    handleButtonUpdate(mobileCheckoutButton, mobileCheckoutButtonCounter, data.detail, 'mobile');
  });
}



function handleButtonUpdate(button, counter, data, kind = 'default') {
  const count = data.mealCount;
  const counterHTML = `<span class="meal-plan-cart-cta__counter">${count}</span>`;
  const totalHTML = `<span class="meal-plan-cart-cta__total"><div class="price-loader"></div></span>`;

  if(kind == "mobile") {

    if (count >= 0 && count < 4) {
      let diff = 4 - count;
      const content = buttonStates.default.replace("[count]", diff);
      button.innerHTML = `${counterHTML} ${content}`;
      button.disabled = true;
      button.classList.add("disabled");
    } else {
      button.innerHTML = `${counterHTML} ${buttonStates.updated}`;
      button.disabled = false;
      button.classList.remove("disabled");
    }
  } else {

    if (count >= 0 && count < 4) {
      let diff = 4 - count;
      const content = buttonStates.default.replace("[count]", diff);
      button.innerHTML = `${counterHTML} ${content} ${totalHTML}`;
      button.disabled = true;
      button.classList.add("disabled");
    } else {
      button.innerHTML = `${counterHTML} ${buttonStates.updated} ${totalHTML}`;
      button.disabled = false;
      button.classList.remove("disabled");
    }
  }

}

function init() {
  addEventListeners();
}

init();

export default init;
